import { useMap } from '@vis.gl/react-google-maps'
import React, { useEffect, useRef } from 'react'

export interface CircleOnMapProps {
  show: boolean
  center: google.maps.LatLngLiteral | undefined
  distance: number | undefined
}

const CircleOnMap: React.FC<CircleOnMapProps> = ({ center, distance, show }) => {
  const map = useMap()
  const circleRef = useRef<google.maps.Circle | null>(null)

  useEffect(() => {
    if (map && show) {
      const circleOptions: google.maps.CircleOptions = {
        strokeColor: '#528DE0',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#528DE0',
        fillOpacity: 0.25,
        map,
        center,
        radius: (distance ?? 0) * 1000,
      }

      circleRef.current = new google.maps.Circle(circleOptions)
      if (center) map.setCenter(center)
    }

    return () => {
      if (circleRef.current) {
        circleRef.current.setMap(null)
      }
    }
  }, [center, distance, map, show])

  useEffect(() => {
    if (map && distance) {
      const fixedPixelRadius = 150

      // Calculate the new zoom level based on the distance
      const scale = (distance * 1000) / fixedPixelRadius
      const lat = map.getCenter()?.lat()
      if (lat) {
        const newZoom = Math.log2((156543.03392 * Math.cos((lat * Math.PI) / 180)) / scale)

        map.setZoom(Math.round(newZoom))
      }
    }
  }, [distance, map])

  return null
}

export default CircleOnMap
